export const EXPERIENCE_TAGS = {
  BOGO: 'BOGO',
  BMSM: 'BMSM',
  MSB: 'MSBONLINE'
};

export const FORWARDS_BOGO_SUBEXPERIENCE_TAGS = {
  buyOneGetOne: 'buyOneGetOne',
  buyOneGetPercentageOff: 'buyOneGetPercentageOff',
  buyOneGetDollarOff: 'buyOneGetDollarOff'
};

export const FORWARDS_BOGO_SUBEXPERIENCES = Object.values(FORWARDS_BOGO_SUBEXPERIENCE_TAGS);

export const BACKWARDS_BOGO_SUBEXPERIENCE_TAGS = {
  buyOneGetOne: 'buyOneGetOneBackwards',
  buyOneGetPercentageOff: 'buyOneGetPercentageOffBackwards',
  buyOneGetDollarOff: 'buyOneGetDollarOffBackwards'
};

export const BACKWARDS_BOGO_SUBEXPERIENCES = Object.values(BACKWARDS_BOGO_SUBEXPERIENCE_TAGS);

export const MAX_NUM_TIERS_IN_PROMOTION = 5;
export const MULTI_SELECT_QUANTITY = 1;

export const MA = 'MAJOR_APPLIANCE';
export const GM = 'MERCHANDISE';
export const NVALUE_REFINEMENT_SEPARATOR = 'Z';
